import { createSlice } from '@reduxjs/toolkit';
import { ICommentVm } from '../models/ICommentVm';

export interface IDiscussionState {
  comments: ICommentVm[];
}

const initialState: IDiscussionState = { comments: [] };

export const discussionSlice = createSlice({
  name: 'discussion',
  initialState,
  reducers: {
    setComments: (
      state: IDiscussionState,
      action: { payload: ICommentVm[] }
    ) => {
      state.comments = action.payload;
    }
  }
});

export const { setComments } = discussionSlice.actions;
export default discussionSlice.reducer;
